<template>
  <b-modal 
    v-model="isVisible"
    hide-footer
  >
      
    <h3 class="text-center">Programar Fecha</h3>

    <div class="my-2">
      <label for="fecha-programada">Seleccione la fecha:</label>
       <b-form-input 
                id="fecha-programada" 
                type="datetime-local" 
                v-model="fechaSelected"
                class="form-control" />
    </div>


    <div class="d-flex justify-content-end mb-2">
      <b-button
        variant="success"
        @click="saveFechaProgramada(tokenProceso, fechaSelected)"
      >
        Programar
      </b-button>
    </div>

  </b-modal>
</template>

<script>
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import { procedimientosService } from '../services';

export default {

  name: "ProgramarFecha",

  created(){
    this.getData();
  },

  data() {
    return {
      isVisible: false,
      fechaSelected: null
    }
  },


  methods:{

    async getData(){

      this.fechaSelected = null;
      this.tokenProceso = this.$route.query.setDate;
      if(!this.tokenProceso) return;

      const responseData = await procedimientosService.getByToken(this.tokenProceso)

      if (!responseData || !responseData.fechaProgramada) {
        this.isVisible = true
        return
      }

      this.fechaSelected = responseData.fechaProgramada
      this.isVisible = true
    },


    
    async saveFechaProgramada(tokenProceso, fechaProgramada) {
      
      const confirmation = await this.$swal({
        title: "¿Estás seguro de actualizar la fecha?",
        text: "No podrás deshacer esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, actualizar",
        cancelButtonText: "Cancelar",
      });

      if (!confirmation.isConfirmed) return;

      const query = `
        mutation actualizarFechaProgramadaPc(
          $tokenProceso   : String!, 
          $fechaProgramada: String!
        ) {
          actualizarFechaProgramadaPc(
            tokenProceso   : $tokenProceso, 
            fechaProgramada: $fechaProgramada
          ) {
            procesocli {
              id
              fechaProgramada
            }
          }
        }
      `;

      const variables = {
        tokenProceso: tokenProceso,
        fechaProgramada: fechaProgramada,
      };

      try {
        const response = await axios.post(rutas.axios + "api", { query, variables });

        if (response.data.errors) {

          this.$swal({
            icon: "error",
            title: "Error",
            text: "Hubo un error en el servidor. Por favor, inténtalo de nuevo más tarde.",
          });

          return;
        } 

        await this.$swal({
          icon: "success",
          title: "Éxito",
          text: "La fecha se actualizó correctamente.",
        });

        this.$router.go(0);

      } catch (error) {
        console.error(error);
      }
      
    },


    onHidden() {
      this.isVisible = false;
    },
  },


  watch: {

    '$route.query.setDate': {
      handler(){
        this.getData();
      },
    },


    isVisible: {
      deep: true,
      handler(newValue) {
        if (!newValue) {
          const updatedQuery = { ...this.$route.query };
          delete updatedQuery.setDate;
          this.$router.push({ path: this.$route.path, query: updatedQuery });
        }
      }
    }
  }
}
</script>
